import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dashboard-header',
    templateUrl: './dashboard-header.component.html',
    styleUrls: ['./dashboard-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardHeaderComponent implements OnInit {
  permissionModules = [];

  constructor() { }

  ngOnInit() {
    this.permissionModules = JSON.parse(localStorage.getItem('permissionModules'));
  }

}
